import {createWebHistory, createRouter} from "vue-router";
import MainContainer from "../views/MainContainer";
import store from "../store";
import AuthPage from "@/views/AuthPage";
import PageNotFound from "@/components/404/PageNotFound";
import Navigations from "@/router/navigation";
import {ElMessage} from "element-plus";

const mainNavigation = [];

function addNavigationItems(navItem) {
    if (navItem.isSubmenu && navItem.children) {
        navItem.children.forEach((childItem) => {
            addNavigationItems(childItem);
        });
    } else {
        mainNavigation.push(navItem);
    }
}

Navigations.forEach((item) => {
    addNavigationItems(item);
});

const routes = [
    {
        path: "/",
        redirect: "/app",
    },
    {
        name: "MainContainer",
        path: "/app",
        component: MainContainer,
        beforeEnter: (to, from, next) => {
            if (store.state.accessToken) {
                const currentUserRole = store.state.role;

                if (to.meta.authorize?.includes(currentUserRole)) {
                    next()
                } else {
                    const defaultPath = mainNavigation.find(item => {
                        if (item.main && item.meta.authorize.includes(currentUserRole)) {
                            return item
                        }
                    })
                    if (defaultPath) {
                        next({name: defaultPath.name})
                    } else {
                        ElMessage.warning("Sizda ushbu sahifaga kirish huquqi mavjud emas")
                    }
                }
            } else {
                next("/auth");
            }
        },
        children: mainNavigation,
    },
    {
        name: "Auth",
        path: "/auth",
        component: AuthPage,
        beforeEnter: (to, from, next) => {
            if (store.state.accessToken) {
                next({path: "/"});
            } else {
                next();
            }
        },
    },
    {
        name: "PageNotFound",
        path: "/:pathMatch(.*)*",
        component: PageNotFound,
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const index = mainNavigation.findIndex((item) => item?.name === to.name);
    store.commit(
        "updateHeaderTitle",
        index > -1 ? mainNavigation[index]?.title || to.name : to.name
    );
    next();
});

export default router;
